<app-dialog-header [title]="'IMAGE_LIBRARY.DIALOG.TITLE'" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div fxLayout="column" fxLayoutAlign="start" class="image-library-dialog-container">
    <mat-tab-group class="image-dialog-group tabs-group" #tabGroup (selectedTabChange)="onTabChanged($event)">
        <mat-tab [label]="'IMAGE_LIBRARY.DIALOG.TABS.MY_IMAGES.TITLE' | translate" class="p-4">
            <mat-tab-group mat-align-tabs="start" class="sub-tabs-group">
                <ng-template matTabContent>
                    <div
                        class="file-drop-container"
                        [disabled]="!tenantDataService.tenantConfig.central_image_library.my_images"
                        cdkDropList
                        (drop)="onFileDropped($event)"
                        (dragover)="onDragOver($event)"
                        (dragleave)="onDragLeave($event)"
                        [class.drag-over]="isDragOver"
                    >
                        <div>
                            <div class="categories-upload-container py-16 px-24" fxLayout="row">
                                <div class="categories">
                                    <span
                                        class="my-images-category-name"
                                        [class.selected]="category.name === selectedCategory"
                                        (click)="onGetMyImages(category.name)"
                                        *ngFor="let category of myImagesCategories"
                                        >{{ category.translation | translate }}</span
                                    >

                                    <div class="auto-width">
                                        <mat-select class="select-option" [(value)]="selectedCategory" (selectionChange)="onGetMyImages($event.value)">
                                            <mat-option [value]="category.name" *ngFor="let category of myImagesCategories">
                                                {{ category.translation | translate }}
                                            </mat-option>
                                        </mat-select>
                                    </div>
                                </div>

                                <div class="drag-and-drop-container" *ngIf="tenantDataService.tenantConfig.central_image_library.my_images">
                                    <label>{{ 'IMAGE_LIBRARY.DIALOG.LABELS.DRAG_AND_DROP_OR' | translate }} &nbsp;</label>

                                    <app-white-button
                                        class="mr-8"
                                        [svgIcon]="'upload'"
                                        [label]="'GENERAL.BUTTON.UPLOAD'"
                                        (onClick)="fileInput.value = ''; fileInput.click()"
                                    ></app-white-button>

                                    <input
                                        type="file"
                                        multiple
                                        style="display: none"
                                        #fileInput
                                        (change)="uploadNewImages($event.target.files)"
                                        accept=".png, .jpg, .jpeg, .bmp, .gif, .webp"
                                    />

                                    <app-icon-button
                                        matTooltip="{{ 'IMAGE_LIBRARY.BUTTONS.SUPPORTED_IMAGE_SIZE_AND_TYPE' | translate }}"
                                        matTooltipClass="mat-image-info-tooltip"
                                        matTooltipPosition="below"
                                        [icon]="'help_outline'"
                                    ></app-icon-button>
                                </div>
                            </div>

                            <div
                                class="white px-12"
                                fxLayout="column"
                                fxLayoutAlign="center center"
                                *ngIf="imageLibraryApiService.fetchingConfig || myImageApiService.fetchingMyImages; else myImagesContent"
                            >
                                <div class="shimmer-container min-w-full">
                                    <div class="shimmer p-12">
                                        <div class="shimmer-card table animate"></div>
                                    </div>
                                </div>
                            </div>

                            <ng-template #myImagesContent>
                                <div class="content px-24 pb-24" id="myImagesContent" (scroll)="onImageListScroll($event)">
                                    <div
                                        class="images-content-container"
                                        *ngIf="!masonryMyImages?.length && selectedCategory === MyImagesCategoriesName.MyImages; else masonryContent"
                                    >
                                        <div class="dropzone-container py-24" *ngIf="tenantDataService.tenantConfig.central_image_library.my_images; else noImages">
                                            <div class="dropzone" fxLayout="row" fxLayoutAlign="center center">
                                                <div class="file-drop-container">
                                                    <input
                                                        type="file"
                                                        multiple
                                                        #fildeDropRef
                                                        id="fileDropRef"
                                                        (change)="uploadNewImages($event.target.files)"
                                                        accept=".png, .jpg, .jpeg, .bmp, .gif, .webp"
                                                    />
                                                    <div class="img-icon"></div>
                                                    <h3>{{ 'IMAGE_LIBRARY.DRAG_AND_DROP.TITLE' | translate }}</h3>
                                                    <h3>{{ 'IMAGE_LIBRARY.DRAG_AND_DROP.OR' | translate }}</h3>

                                                    <app-flat-button
                                                        class="px-32"
                                                        [label]="'IMAGE_LIBRARY.BUTTONS.SELECT_FILES'"
                                                        (onClick)="fildeDropRef.click()"
                                                    ></app-flat-button>
                                                </div>
                                            </div>
                                        </div>
                                        <ng-template #noImages>
                                            <div class="no-images-container py-12" *ngIf="!masonryTenantImages?.length; else masonryTenant">
                                                <div class="no-images">
                                                    <p class="no-images-text pt-24">
                                                        {{ 'IMAGE_LIBRARY.TABS.TENANT_LIBRARY.CONTENT.NO_IMAGES_TITLE' | translate }}
                                                    </p>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </div>
                                    <ng-template #masonryContent>
                                        <div class="no-images-container py-12" *ngIf="!masonryMyImages?.length; else masonryImages">
                                            <div class="no-images">
                                                <p class="no-images-text pt-24">{{ 'IMAGE_LIBRARY.TABS.MY_IMAGES.CONTENT.NO_IMAGES_TEXT' | translate }}</p>
                                            </div>
                                        </div>
                                        <ng-template #masonryImages>
                                            <div class="masonry">
                                                <div class="masonry-grid">
                                                    <div class="masonry-column" *ngFor="let column of myImageColumns">
                                                        <div
                                                            class="grid-item pointer"
                                                            *ngFor="let image of column; trackBy: trackByImageId"
                                                            (click)="onSelectImage(image)"
                                                            [class.selected]="selectedImage && selectedImage.id === image.id"
                                                        >
                                                            <div
                                                                *ngIf="selectedCategory === MyImagesCategoriesName.MyImages"
                                                                class="detele-img-icon-container"
                                                                (click)="openDeleteImageDialog(image.id); $event.stopPropagation()"
                                                            >
                                                                <mat-icon>delete</mat-icon>
                                                            </div>
                                                            <div class="overlay"></div>
                                                            <div class="selected-overlay"></div>
                                                            <div class="author-container" *ngIf="image.unsplash">
                                                                <a class="author-name" [href]="image.unsplash.authorProfileUrl" target="_blank" (click)="$event.stopPropagation()">
                                                                    {{ image.unsplash.authorName }}
                                                                </a>
                                                            </div>
                                                            <div class="image-shimmer animate"></div>
                                                            <img
                                                                #photo
                                                                class="masonry-image"
                                                                [class.is-loaded]="photo.complete"
                                                                [src]="image.url"
                                                                alt=""
                                                                width="100%"
                                                                [style.aspect-ratio]="masonryAspectRatios[image.id] || '4 / 3'"
                                                                (load)="onMasonryImageLoad($event)"
                                                            />
                                                            <img
                                                                style="display: none"
                                                                alt=""
                                                                masonryLazy
                                                                *ngIf="image.unsplash"
                                                                [src]="unsplashViewsBaseUrl + image.unsplash.unsplashId"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="image-scroll-sentinel"></div>
                                            </div>
                                        </ng-template>
                                    </ng-template>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </ng-template>
            </mat-tab-group>
        </mat-tab>
        <mat-tab [label]="'IMAGE_LIBRARY.DIALOG.TABS.TENANT_LIBRARY.TITLE' | translate" *ngIf="tenantDataService.tenantConfig.central_image_library.tenant_library">
            <mat-tab-group class="sub-tabs-group" mat-align-tabs="start">
                <ng-template matTabContent>
                    <div
                        class="white px-12"
                        fxLayout="column"
                        fxLayoutAlign="center center"
                        *ngIf="imageLibraryApiService.fetchingConfig || tenantLibraryApiService.fetchingTenantImages; else myTenantImagesContent"
                    >
                        <div class="shimmer-container min-w-full">
                            <div class="shimmer p-12">
                                <div class="shimmer-card table animate"></div>
                            </div>
                        </div>
                    </div>

                    <ng-template #myTenantImagesContent>
                        <div class="content p-24 pt-0" id="tenantImagesContent" (scroll)="onImageListScroll($event)">
                            <div class="no-images-container" *ngIf="!masonryTenantImages?.length; else masonryTenant">
                                <div class="no-images">
                                    <p class="pt-24">
                                        {{ 'IMAGE_LIBRARY.TABS.TENANT_LIBRARY.CONTENT.NO_IMAGES_TITLE' | translate }}
                                    </p>
                                </div>
                            </div>
                            <ng-template #masonryTenant>
                                <div class="masonry py-16">
                                    <div class="masonry-grid">
                                        <div class="masonry-column" *ngFor="let column of tenantImageColumns">
                                            <div
                                                class="grid-item pointer"
                                                *ngFor="let image of column; trackBy: trackByImageId"
                                                (click)="onSelectImage(image)"
                                                [class.selected]="selectedImage && selectedImage.id === image.id"
                                            >
                                                <div class="overlay"></div>
                                                <div class="selected-overlay"></div>
                                                <div class="author-container" *ngIf="image.unsplash">
                                                    <a class="author-name" [href]="image.unsplash.authorProfileUrl" target="_blank" (click)="$event.stopPropagation()">
                                                        {{ image.unsplash.authorName }}
                                                    </a>
                                                </div>
                                                <div class="image-shimmer animate"></div>
                                                <img
                                                    #photo
                                                    class="masonry-image"
                                                    [class.is-loaded]="photo.complete"
                                                    [src]="image.url"
                                                    width="100%"
                                                    alt=""
                                                    [style.aspect-ratio]="masonryAspectRatios[image.id] || '4 / 3'"
                                                    (load)="onMasonryImageLoad($event)"
                                                />
                                                <img
                                                    style="display: none"
                                                    *ngIf="image.unsplash"
                                                    alt=""
                                                    masonryLazy
                                                    [src]="unsplashViewsBaseUrl + image.id"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="image-scroll-sentinel"></div>
                                </div>
                            </ng-template>
                        </div>
                    </ng-template>
                </ng-template>
            </mat-tab-group>
        </mat-tab>
        <mat-tab [label]="'IMAGE_LIBRARY.DIALOG.TABS.UNSPLASH.TITLE' | translate" *ngIf="tenantDataService.tenantConfig.central_image_library.unsplash">
            <mat-tab-group class="sub-tabs-group" mat-align-tabs="start">
                <ng-template matTabContent>
                    <div class="categories-upload-container has-search px-24 pt-12" fxLayout="row">
                        <div class="categories">
                            <span [class.selected]="category.name === selectedCategory" (click)="onGetUnsplashImages(category.name)" *ngFor="let category of unsplashCategories">{{
                                category.translation | translate
                            }}</span>
                        </div>
                        <app-search-outline [searchInput]="searchInput"></app-search-outline>
                    </div>

                    <div
                        class="white px-12"
                        fxLayout="column"
                        fxLayoutAlign="center center"
                        *ngIf="imageLibraryApiService.fetchingConfig || unsplashApiService.fetchingUnsplashImages; else unsplashImagesContent"
                    >
                        <div class="shimmer-container min-w-full">
                            <div class="shimmer p-12">
                                <div class="shimmer-card table animate"></div>
                            </div>
                        </div>
                    </div>

                    <ng-template #unsplashImagesContent>
                        <div class="content p-24 pt-0" id="unsplashImagesContent" (scroll)="onImageListScroll($event)">
                            <div class="no-images-container" *ngIf="!masonryUnsplashImages?.length; else masonryUnsplash">
                                <div class="no-images">
                                    <p class="pt-24">
                                        {{ 'IMAGE_LIBRARY.TABS.UNSPLASH.CONTENT.NO_IMAGES_TEXT' | translate }}
                                    </p>
                                </div>
                            </div>
                            <ng-template #masonryUnsplash>
                                <div class="masonry py-16">
                                    <div class="masonry-grid">
                                        <div class="masonry-column" *ngFor="let column of unsplashColumns">
                                            <div
                                                class="grid-item pointer"
                                                *ngFor="let image of column; trackBy: trackByImageId"
                                                (click)="onSelectImage(image)"
                                                [class.selected]="selectedImage && selectedImage.id === image.id"
                                            >
                                                <div class="overlay"></div>
                                                <div class="selected-overlay"></div>
                                                <div class="author-container">
                                                    <a class="author-name" [href]="image.user.links.html" target="_blank" (click)="$event.stopPropagation()">
                                                        {{ image.user.name }}
                                                    </a>
                                                </div>
                                                <div class="image-shimmer animate"></div>
                                                <img
                                                    #photo
                                                    class="masonry-image"
                                                    [class.is-loaded]="photo.complete"
                                                    [src]="image.urls.regular"
                                                    alt=""
                                                    width="100%"
                                                    [style.aspect-ratio]="masonryAspectRatios[image.id] || '4 / 3'"
                                                    (load)="onMasonryImageLoad($event)"
                                                />
                                                <img style="display: none" alt="" masonryLazy [src]="unsplashViewsBaseUrl + image.id" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="image-scroll-sentinel"></div>
                                </div>
                            </ng-template>
                        </div>
                    </ng-template>
                </ng-template>
            </mat-tab-group>
        </mat-tab>
        <mat-tab class="ai-images-tab" *ngIf="isAiImagesFeatureActive">
            <ng-template mat-tab-label>
                {{ 'IMAGE_LIBRARY.TABS.AI_IMAGES.TITLE' | translate }}
            </ng-template>
            <mat-tab-group class="sub-tabs-group" mat-align-tabs="start">
                <ng-template matTabContent>
                    <div class="categories-upload-container px-24 pt-12" fxLayout="column" fxLayoutAlign="center flex-start" fxLayoutGap="10px">
                        <label class="prompt-desc">{{ 'IMAGE_LIBRARY.DIALOG.LABELS.PROMPT_INFO' | translate }}</label>
                        <div fxLayout="row" fxLayoutGap="8px" class="w-100-p">
                            <mat-form-field class="search-ai-wrapper" floatLabel="never" fxFlex="1 0 auto" appearance="fill">
                                <input
                                    matInput
                                    type="text"
                                    [formControl]="aiImagesSearchInput"
                                    [placeholder]="'IMAGE_LIBRARY.TABS.AI_IMAGES.LABEL.INPUT_PLACEHOLDER' | translate"
                                    (keyup)="handleKeyUp($event, aiImagesSearchInput.value)"
                                />
                            </mat-form-field>

                            <app-flat-button
                                class="generate-ai-button"
                                [label]="'GENERAL.BUTTON.GENERATE'"
                                (onClick)="generateImage(aiImagesSearchInput.value)"
                                [disabled]="!aiImagesSearchInput.value || isAiImageLoading"
                            ></app-flat-button>
                        </div>
                    </div>

                    <div class="white px-12" fxLayout="column" fxLayoutAlign="center center" *ngIf="isAiImageLoading; else aiCreatedImagesContent">
                        <div class="shimmer-container min-w-full">
                            <div class="shimmer p-12">
                                <div class="shimmer-card table animate"></div>
                            </div>
                        </div>
                    </div>

                    <ng-template #aiCreatedImagesContent>
                        <div class="content p-24 pt-0" id="aiCreatedImagesContent">
                            <div class="no-images-container" *ngIf="!aiCreatedImage; else createdImage">
                                <div fxLayout="column" fxLayoutAlign="space-between center" class="pt-24">
                                    <div class="no-results-container mb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <mat-icon class="participant-view-illustration" svgIcon="search_illustration"></mat-icon>
                                    </div>
                                </div>
                            </div>
                            <ng-template #createdImage>
                                <div
                                    class="ai-image-wrapper mt-16"
                                    [class.selected]="selectedImage && selectedImage.id === aiCreatedImage.id"
                                    (click)="onSelectImage(aiCreatedImage)"
                                >
                                    <div class="overlay"></div>
                                    <div class="selected-overlay"></div>
                                    <img [src]="'data:image/png;base64,' + aiCreatedImage.image" alt="" width="100%" />
                                </div>
                            </ng-template>
                        </div>
                    </ng-template>
                </ng-template>
            </mat-tab-group>
        </mat-tab>
    </mat-tab-group>
</div>
